<div *ngIf="itemList"
	[class.active]="isOpenSelect"
	class="input-line select">
	<p class="input-line__name">{{ title }}</p>
	<label (click)="toggleSelect()"
		class="label">
		<input [value]="selectedItem?.description"
			[disabled]="isDisableSelect"
			readonly
			class="input-line__input"
			type="text">
	</label>
	<ul #selectList
		*ngIf="itemList.length > 0"
		[class.top]="positionList === 'top'"
		[class.bottom]="positionList === 'bottom'"
		(scroll)="checkScrollPosition($event)"
		class="select__list">
		<li *ngFor="let item of itemList"
			(click)="setSelectedItem(item)"
			class="select__list-item">
			{{ item.description }}
		</li>
	</ul>
</div>
